module.exports = __webpack_public_path__ + "static/media/skype.19170aa5.svg";